<script setup>
import { Link } from '@inertiajs/vue3'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'
import { useI18n } from 'vue-i18n'

defineProps({
  row: { type: Object, required: true }
})
const { t } = useI18n()
</script>

<template>
  <Link
    :href="row.id ? `/vehicles/${row.id}` : null"
    class="block rounded-[var(--radius-md)] border border-[color:var(--line)] bg-[color:var(--surface)] p-3 mb-2"
  >
    <div class="flex items-baseline gap-2 mb-2">
      <div class="font-semibold">{{ row.registration || row.label }}</div>
      <div v-if="row.make" class="text-sm text-[color:var(--inkSoft)]">{{ row.make }} {{ row.model }}</div>
      <UiStatusPill
        v-if="row.vehicle_class"
        tone="muted"
        class="ml-auto capitalize"
        :label="t(`vehicles.classes.${row.vehicle_class}`)"
      />
    </div>
    <div class="grid grid-cols-3 gap-2 text-sm">
      <div>
        <div class="text-xs text-[color:var(--muted)]">{{ t('reports.vehicles.cols.gross') }}</div>
        <div class="fw-value tabular-nums">{{ row.gross }}</div>
      </div>
      <div>
        <div class="text-xs text-[color:var(--muted)]">{{ t('reports.vehicles.cols.net') }}</div>
        <div class="fw-value tabular-nums">{{ row.net }}</div>
      </div>
      <div>
        <div class="text-xs text-[color:var(--muted)]">{{ t('reports.vehicles.cols.utilization') }}</div>
        <div class="fw-value tabular-nums">{{ row.utilization_pct }}%</div>
      </div>
    </div>
    <div class="mt-2 text-xs text-[color:var(--muted)]">
      {{ row.rentals_count }} {{ t('reports.vehicles.cols.rentals') }} · {{ row.days_rented }} {{ t('reports.vehicles.cols.days') }}
    </div>
  </Link>
</template>
